<template>
  <div class="note note-adder">
    <a href="#" class="circle add-note" @click.prevent="toggleCreating">
      <i class="fa fa-minus" v-if="creating"></i>
      <i class="fa fa-plus" v-else></i>
    </a>
    <NoteForm
      ref="form"
      v-show="creating"
      :initialMarkdown="''"
      :commentsMode="commentsMode"
      @save="onSave"
      @cancel="onCancel"
    />
  </div>
</template>

<script>
 import NoteForm from './NoteForm';
 import {showError} from 'perform-base/js/flashes';

 export default {
   props: [
     'entityType',
     'entityId',
     'commentsMode',
   ],
   data() {
     return {
       creating: false,
     };
   },
   components: {
     NoteForm,
   },

   computed: {
     availableTypes() {
       return [
         {name: 'Note', value: 0, icon: 'pencil'},
         {name: 'Email', value: 1, icon: 'envelope'},
         {name: 'Call', value: 2, icon: 'phone'},
         {name: 'Meeting', value: 3, icon: 'user'},
         {name: 'Message', value: 4, icon: 'mobile'},
       ];
     },
     html() {
       return md.render(this.markdown);
     }
   },

   methods: {
     setType(type) {
       this.noteType = type;
     },
     badgeClass(type) {
       var badgeClasses = [
         'fa-pencil',
         'fa-envelope',
         'fa-phone',
         'fa-user',
         'fa-mobile',
       ];

       return badgeClasses[type];
     },
     onSave(e) {
       this.$store.dispatch('createNote', {
         entityType: this.entityType,
         entityId: this.entityId,
         markdown: e.markdown,
         type: e.noteType,
       })
           .then(() => {
             this.creating = false;
             this.$refs.form.reset();
           })
           .catch(() => {
             showError('An error occurred creating this comment. Try again later.');
           });
     },
     onCancel(e) {
       this.creating = false;
     },
     toggleCreating() {
       this.creating = !this.creating;
       if (this.creating) {
         this.$nextTick(() => {
           this.$refs.form.focus();
         });
       }
     }
   }
 };
</script>



// WEBPACK FOOTER //
// assets/js/components/NoteAdder.vue